export const EPS_PROVIDER_CODE = 'EPS'

/**
 *
 * Determines if {@link EPS_PROVIDER_CODE} is the provider for the given provider code.
 *
 * @example
 *
 * ```
 * isEpsProvider(providerCode)
 * ```
 *
 * @param providerCode - The provider code you are checking if it's {@link EPS_PROVIDER_CODE} provider or not
 *
 * @returns Whether {@link EPS_PROVIDER_CODE} is the provider for the given provider code or not
 */
export const isEpsProvider = (providerCode: string) =>
  providerCode === EPS_PROVIDER_CODE
